// DROPDOWN

document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('.dropdown-toggle');
    const submenus = document.querySelectorAll('.dropdown__submenu');

    function handleHover() {
        this.classList.add('open');
        this.querySelector('.dropdown__submenu').style.display = 'block';
    }

    function handleMouseOut() {
        this.classList.remove('open');
        this.querySelector('.dropdown__submenu').style.display = 'none';
    }

    function handleClick(e) {
        e.preventDefault();
        const submenu = this.nextElementSibling;
        const isOpen = this.classList.contains('open');

        toggles.forEach(toggle => {
            toggle.classList.remove('open');
            toggle.nextElementSibling.style.display = 'none';
        });

        if (!isOpen) {
            this.classList.add('open');
            submenu.style.display = 'block';
        }
    }

    toggles.forEach(toggle => {
        toggle.parentElement.addEventListener('mouseenter', handleHover);
        toggle.parentElement.addEventListener('mouseleave', handleMouseOut);
        toggle.addEventListener('click', handleClick);
    });

    document.addEventListener('click', function(e) {
        if (!e.target.matches('.dropdown-toggle') && !e.target.closest('.dropdown__submenu')) {
            toggles.forEach(toggle => {
                toggle.classList.remove('open');
                toggle.nextElementSibling.style.display = 'none';
            });
        }
    });
});